import React, { createContext, useState, useContext } from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

const AlertContext = createContext();
export const useAlert = () => useContext(AlertContext);

export const AlertProvider = ({ children }) => {
  const [alert, setAlert] = useState({ open: false, message: '', severity: 'success' });

  const [authToken,setAuthToken] = useState(false);

 const setToken = (token) => {
     setAuthToken(token);
   };

  const [state, setState] = useState({
    vertical: 'top',
    horizontal: 'center',
  });
  
  const { vertical, horizontal } = state;

  const showAlert = (message, severity) => {
    setAlert({ open: true, message, severity });
  };



  const handleClose = () => {
    setAlert({ ...alert, open: false });
  };

  return (
    <AlertContext.Provider value={{showAlert,setToken,authToken}}>
      {children}
      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={alert.open}
        autoHideDuration={3000}
        onClose={handleClose}
        key={vertical + horizontal}
      >
        <Alert onClose={handleClose} severity={alert.severity} sx={{ width: '100%' }}>
          {alert.message}
        </Alert>
      </Snackbar>
    </AlertContext.Provider>
  );
};
